import React from "react";

const Profile: React.FC = () => {
  return <h1>Profile Page</h1>;
};

export default Profile;

